import { ReactNode } from "react";
import cx from "classnames";

import styles from "./styles.module.css";
import Box, { BoxProps } from "../Box";

type ModalFooterProps = {
  children: ReactNode;
  className?: string;
} & BoxProps;

const ModalFooter = ({ children, className, ...boxProps }: ModalFooterProps) => {
  return (
    <Box className={cx(styles.footer, className)} align="center" justify="end" {...boxProps}>
      {children}
    </Box>
  );
};

ModalFooter.displayName = "DS.Modal.Footer";

export default ModalFooter;
